import { MLink } from '../../mdl/m-template';
import { UIValue } from '../../ui/types';
import { EDEditor } from '../editor';

export const ed_email_decoration_values: UIValue<string>[] = [{ key: 'none', name: 'None' }, { key: 'pink', name: 'Pink' }];

export type EDEmailEditor = EDEditor<any, any, any> & { link_values: UIValue<MLink>[] }
